import { render, staticRenderFns } from "./RollerBrakeTester.vue?vue&type=template&id=5ce97207&scoped=true&"
import script from "./RollerBrakeTester.vue?vue&type=script&lang=js&"
export * from "./RollerBrakeTester.vue?vue&type=script&lang=js&"
import style0 from "./RollerBrakeTester.vue?vue&type=style&index=0&id=5ce97207&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce97207",
  null
  
)

export default component.exports